<template>
  <div>
    <!-- 轮播图 -->
    <div
      v-if="selType == 'bigimg'"
      :class="{ swbaner2: windowWidth < 751 }"
      class="swbaner"
      style="border-radius: 12px; overflow: hidden"
    >
      <b-skeleton-img></b-skeleton-img>
    </div>

    <!-- 热门分类 -->
    <b-row
      v-if="selType == '2'"
      class="pb-0 d-flex"
      cols="2"
      cols-sm="2"
      cols-md="4"
      cols-lg="4"
    >
      <b-col
        class="m-0 mb-3"
        v-for="(item, index) in 8"
        :key="index"
        style="height: 83px"
      >
        <b-skeleton-img
          height="83px"
          style="border-radius: 8px"
        ></b-skeleton-img>
      </b-col>
    </b-row>

    <!-- 主页的列表 -->
    <template v-if="selType == '3'">
      <div v-for="(item, index) in 1" :key="index">
        <b-row class="pt-4 pb-3 fwight">
          <b-col class="d-flex justify-content-between align-items-center">
            <b-skeleton animation="wave" width="20%"></b-skeleton>
            <b-skeleton animation="wave" width="80px"></b-skeleton>
          </b-col>
        </b-row>
        <b-row
          v-if="selType == '3'"
          class="pb-4 d-flex"
          cols="1"
          cols-sm="2"
          cols-md="3"
          cols-lg="4"
        >
          <b-col class="mb-3" v-for="(ite, ind) in 4" :key="ind">
            <div
              class="d-flex flex-column justify-content-between pushpub align-items-start"
              style="padding: 10px"
            >
              <div class="d-flex" style="width: 100%">
                <div
                  class="d-flex align-items-center"
                  style="
                    margin-right: 5px;
                    width: 80px;
                    height: 80px;
                    overflow: hidden;
                    margin-right: 10px;
                  "
                >
                  <b-skeleton-img
                    height="80px"
                    width="80px"
                    style=""
                  ></b-skeleton-img>
                </div>
                <div
                  style="
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                  "
                >
                  <div class="pushtil" style="margin-top: 8px">
                    <b-skeleton animation="wave" width="85%"></b-skeleton>
                  </div>
                  <div style="margin-top: 8px" class="topsty">
                    <b-skeleton animation="wave" width="85%"></b-skeleton>
                  </div>
                </div>
              </div>

              <div style="height: 60px; overflow: hidden" class="mt-2">
                <div v-for="(a1, b1) in 8" :key="b1" class="pushtyps m-1">
                  <b-skeleton animation="wave" width="40px"></b-skeleton>
                </div>
              </div>
              <div
                class="mt-2"
                style="
                  border-radius: 8px;
                  overflow: hidden;
                  height: 150px;
                  width: 100%;
                "
                :style="{ height: windowWidth < 751 ? '250px' : '200px' }"
              >
                <b-skeleton
                  animation="wave"
                  width="100%"
                  height="200px"
                ></b-skeleton>
              </div>

              <div
                style="
                  width: 100%;
                  border-radius: 8px;
                  text-align: center;
                  color: #014099;
                  font-weight: 600;
                  font-size: 18px;
                  word-wrap: break-word;
                "
                class="mt-3 p-1"
              >
                <b-skeleton animation="wave" width="100%"></b-skeleton>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-4 mb-4">
          <b-col class="d-flex justify-content-between align-items-center">
            <div
              class="bgimg"
              style="cursor: pointer"
              :style="{ height: windowWidth >= 768 ? 300 + 'px' : 140 + 'px' }"
            >
              <b-skeleton
                v-if="windowWidth >= 768"
                animation="wave"
                height="300px"
                width="100%"
              ></b-skeleton>
              <b-skeleton
                v-else
                animation="wave"
                height="140px"
                width="100%"
              ></b-skeleton>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
    <!-- 联系我们 -->
    <b-row v-if="selType == '15'">
      <b-col>
        <div>
          <b-skeleton
            animation="wave"
            :height="windowWidth < 751 ? '100px' : '300px'"
            width="100%"
          ></b-skeleton>
        </div>
        <div class="item-title mt-4" style="font-size: 40rpx">
          <b-skeleton animation="wave" height="30px" width="10%"></b-skeleton>
        </div>
        <div class="class-font mt-2">
          <b-skeleton animation="wave" height="30px" width="20%"></b-skeleton>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="selType == '12'" align-h="between" class="mt-4 mb-5">
      <b-col lg="6" md="8" v-for="item in 4" :key="item" class="mb-2">
        <b-skeleton animation="wave" height="56px" width="100%"></b-skeleton>
      </b-col>
    </b-row>
    <!-- 地图 -->
    <b-row v-if="selType == '13'" class="mt-3 mb-3">
      <b-skeleton animation="wave" height="376px" width="100%"></b-skeleton>
    </b-row>
    <!-- 填写-->

    <b-row
      v-if="selType == '13'"
      class="d-flex align-items-center justify-content-between"
    >
      <b-col md="8">
        <div style="font-size: 40rpx; font-weight: bolder" class="mt-3">
          <b-skeleton animation="wave" height="56px" width="100%"></b-skeleton>
        </div>
        <b-skeleton animation="wave" height="50px" width="100%"></b-skeleton>
        <b-skeleton animation="wave" height="50px" width="100%"></b-skeleton>

        <b-skeleton animation="wave" height="130px" width="100%"></b-skeleton>
        <div class="btncenter">
          <b-skeleton animation="wave" height="56px" width="20%"></b-skeleton>
        </div>
      </b-col>
      <b-col md="3">
        <div
          style="
            font-size: 40rpx;
            font-weight: bolder;
            display: flex;
            align-items: center;
          "
          class="mt-3 text-center"
        >
          <b-skeleton animation="wave" height="45px" width="100%"></b-skeleton>
        </div>
        <div
          class="mt-3 d-flex align-items-start justify-content-between text-center"
          style=""
        >
          <div class="">
            <b-skeleton
              animation="wave"
              height="150px"
              width="150px"
            ></b-skeleton>

            <div style="font-size: 32rpx; color: #90969e" class="m-3">
              <b-skeleton
                animation="wave"
                height="40px"
                width="100px"
              ></b-skeleton>
            </div>
          </div>
          <div class="">
            <b-skeleton
              animation="wave"
              height="150px"
              width="150px"
            ></b-skeleton>

            <div style="font-size: 32rpx; color: #90969e" class="m-3">
              <b-skeleton
                animation="wave"
                height="40px"
                width="100px"
              ></b-skeleton>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- shop list -->
    <div class="class-left nones" v-if="selType == '5'">
      <div class="class-item" v-for="(item, index) in 10" :key="index">
        <div
          :style="{ borderBottom: index != 9 ? '1px solid #EEEEEE' : '' }"
          style="width: 194px"
        >
          <div
            class="item-title"
            style="
              margin-left: 0px;
              margin-top: 20px;
              cursor: pointer;
              text-indent: 0.6em;
            "
          >
            <b-skeleton
              animation="wave"
              height="40px"
              width="100%"
            ></b-skeleton>
          </div>
          <div
            v-if="false"
            v-for="(item1, index1) in 4"
            :key="index1"
            style="text-indent: 0.6em; margin-top: 15px"
            class="activaa"
          >
            <b-skeleton
              animation="wave"
              height="40px"
              width="100%"
            ></b-skeleton>
          </div>
        </div>
      </div>
    </div>
    <!-- 大卡片 列表-->

    <b-row
      v-if="selType == '4'"
      class="pb-4 d-flex"
      cols="1"
      cols-sm="2"
      cols-md="3"
      cols-lg="4"
    >
      <b-col class="mb-3" v-for="(ite, ind) in 20" :key="ind">
        <div
          class="d-flex flex-column justify-content-between pushpub align-items-start"
          style="padding: 10px"
        >
          <div class="d-flex" style="width: 100%">
            <div
              class="d-flex align-items-center"
              style="
                margin-right: 5px;
                width: 80px;
                height: 80px;
                overflow: hidden;
                margin-right: 10px;
              "
            >
              <b-skeleton-img
                height="80px"
                width="80px"
                style=""
              ></b-skeleton-img>
            </div>
            <div
              style="
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                overflow: hidden;
              "
            >
              <div class="pushtil" style="margin-top: 8px">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
              </div>
              <div style="margin-top: 8px" class="topsty">
                <b-skeleton animation="wave" width="85%"></b-skeleton>
              </div>
            </div>
          </div>

          <div style="height: 60px; overflow: hidden" class="mt-2">
            <div v-for="(a1, b1) in 8" :key="b1" class="pushtyps m-1">
              <b-skeleton animation="wave" width="40px"></b-skeleton>
            </div>
          </div>
          <div
            class="mt-2"
            style="
              border-radius: 8px;
              overflow: hidden;
              height: 150px;
              width: 100%;
            "
            :style="{ height: windowWidth < 751 ? '250px' : '200px' }"
          >
            <b-skeleton
              animation="wave"
              width="100%"
              height="200px"
            ></b-skeleton>
          </div>

          <div
            style="
              width: 100%;
              border-radius: 8px;
              text-align: center;

              color: #014099;
              font-weight: 600;
              font-size: 18px;
              word-wrap: break-word;
            "
            class="mt-3 p-1"
          >
            <b-skeleton animation="wave" width="100%"></b-skeleton>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- 小卡片 一行4个 -->

    <b-row
      v-if="selType == '16'"
      class="pb-4 d-flex mt-2"
      cols="2"
      cols-sm="3"
      cols-md="4"
      cols-lg="4"
      style="margin-right: 2px; cursor: pointer"
    >
      <b-col
        class="mb-2 mt-2"
        v-for="(item, index) in 12"
        :key="index"
        style=""
      >
        <div
          class="class-kuai"
          style="box-sizing: border-box; padding: 15px; border-radius: 18px"
        >
          <div
            class=""
            style="
              background-color: transparent;
              height: 10%;
              box-sizing: border-box;
              border-radius: 8px;
              overflow: hidden;
            "
          >
            <b-skeleton
              animation="wave"
              :height="windowWidth < 420 ? '100px' : '160px'"
              width="100%"
            ></b-skeleton>
          </div>
          <div class="mt-1" style="text-align: left; width: 100%">
            <b-skeleton
              animation="wave"
              height="24px"
              width="80px"
            ></b-skeleton>
          </div>

          <div class="d-flex justify-content-start align-items-center">
            <div class="" style="border-radius: 8px; margin-top: 4px">
              <b-skeleton
                animation="wave"
                height="24px"
                width="40px"
              ></b-skeleton>
            </div>
          </div>
          <div
            class=""
            style="font-size: 14px; text-align: left; margin-top: 4px"
          >
            <b-skeleton animation="wave" height="24px" width="50%"></b-skeleton>
            <b-skeleton
              animation="wave"
              height="24px"
              width="100%"
            ></b-skeleton>
          </div>

          <div style="margin-top: 10px">
            <b-skeleton
              animation="wave"
              height="35px"
              width="100%"
            ></b-skeleton>
          </div>
        </div>
      </b-col>
    </b-row>
    <!--详情 头部   -->
    <b-col
      v-if="selType == '9'"
      :style="{ width: windowWidth > 751 ? 'calc(100% - 40px)' : '100%' }"
    >
      <div v-if="windowWidth >= 768" style="margin-left: 40px">
        <b-card
          no-body
          class="overflow-hidden deta"
          style="border: 1px solid transparent"
        >
          <b-row no-gutters>
            <b-col md="3">
              <b-skeleton
                animation="wave"
                height="100%"
                width="100%"
              ></b-skeleton>
            </b-col>
            <b-col md="9" class="">
              <b-card-body title="" class="p-0 m-0">
                <b-card-text style="text-align: left; color: #1a1a1a">
                  <div
                    style="
                      display: flex;
                      flex-direction: column;
                      justify-content: space-between;
                      height: 200px;
                      align-items: flex-start;
                    "
                  >
                    <div>
                      <div
                        style="font-weight: bold; font-size: 30px"
                        class="mb-2 wrap"
                      >
                        <b-skeleton
                          animation="wave"
                          height="35px"
                          width="80px"
                        ></b-skeleton>
                      </div>
                      <div class="pushcont mb-3">
                        <b-skeleton
                          animation="wave"
                          height="35px"
                          width="500px"
                        ></b-skeleton>
                        <b-skeleton
                          animation="wave"
                          height="35px"
                          width="700px"
                        ></b-skeleton>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-between align-items-center"
                      style="width: 100%"
                    >
                      <div style="height: 40px; overflow: hidden">
                        <div
                          v-for="ite in 3"
                          :key="ite"
                          style="
                            display: inline-block;
                            border-radius: 8px;
                            font-size: 14px;
                            background: #e1e3e7;
                            margin: 4px 4px;
                          "
                        >
                          <b-skeleton
                            animation="wave"
                            height="35px"
                            width="80px"
                          ></b-skeleton>
                        </div>
                      </div>

                      <div>
                        <b-skeleton
                          animation="wave"
                          height="35px"
                          width="170px"
                        ></b-skeleton>
                      </div>
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <div v-else>
        <b-row class="m-2">
          <b-col class="d-flex">
            <b-skeleton
              animation="wave"
              height="100px"
              width="100px"
            ></b-skeleton>
            <div
              class="d-flex flex-column align-items-start justify-content-center"
            >
              <div
                style="font-weight: bold; font-size: 20px; margin-left: 20px"
                class="mb-2"
              >
                <b-skeleton
                  animation="wave"
                  height="35px"
                  width="80px"
                ></b-skeleton>
              </div>
              <div
                style="
                  background: #e1e3e7;
                  display: inline-block;
                  border-radius: 8px;
                  font-size: 12px;
                  margin-top: 10px;
                "
              ></div>
            </div>
          </b-col>
        </b-row>

        <b-row class="m-2">
          <b-col style="">
            <div style="font-size: 12px; display: flex" class="pushcont">
              <b-skeleton
                v-for="(im, ix) in 4"
                :key="ix"
                style="margin-right: 6px"
                animation="wave"
                height="28px"
                width="40px"
              ></b-skeleton>
            </div>
          </b-col>
        </b-row>

        <b-row class="m-2">
          <b-col style="">
            <div style="font-size: 12px; text-align: left" class="pushcont">
              <b-skeleton
                animation="wave"
                height="30px"
                width="60%"
              ></b-skeleton>
              <b-skeleton
                animation="wave"
                height="30px"
                width="100%"
              ></b-skeleton>
            </div>
          </b-col>
        </b-row>
        <b-row class="m-2">
          <b-col style="">
            <div
              style="font-size: 12px; text-align: left; margin-top: 15px"
              class="pushcont"
            >
              <b-skeleton
                animation="wave"
                height="35px"
                width="100%"
              ></b-skeleton>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <!-- 轮播图 详情 -->

    <div v-if="selType == '10'">
      <b-row
        class="mt-4"
        v-if="windowWidth >= 750"
        style="
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
        "
      >
        <div
          class=""
          style="
            font-size: 40px;
            position: absolute;
            left: -5px;
            top: 50%;
            width: 40px;
            transform: translateY(-50%);
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 35px;
              height: 35px;
              border-radius: 50%;
            "
          >
            <div class="poincsw" style="">
              <b-img
                @click="reduce()"
                class="poinc"
                :src="require('../../static/staimg/left.png')"
                width="9"
                style="object-fit: cover"
                alt=""
              ></b-img>
            </div>
          </div>
        </div>

        <b-col cols="11" class="p-0 m-2 d-flex">
          <div
            class="d-flex justify-content-between align-items-center"
            style="cursor: pointer; width: 100%"
            :style="{ width: 100 + '%', margin: '0 auto' }"
          >
            <div
              class="d-flex justify-content-between align-items-center"
              style="width: 49.5%; height: 400px"
            >
              <b-skeleton
                style="margin-right: 20px"
                animation="wave"
                height="100%"
                width="100%"
              ></b-skeleton>
            </div>
            <div
              class="d-flex justify-content-between align-items-center"
              style="width: 49.5%; height: 400px"
            >
              <b-skeleton
                style="margin-left: 10px"
                animation="wave"
                height="100%"
                width="100%"
              ></b-skeleton>
            </div>
          </div>
        </b-col>

        <div
          class=""
          style="
            font-size: 40px;
            position: absolute;
            right: 18px;
            top: 50%;
            width: 40px;
            transform: translateY(-50%);
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              width: 35px;
              height: 35px;
              border-radius: 50%;
            "
          >
            <div class="poincsw" style="">
              <b-img
                @click="add()"
                class="poinc"
                :src="require('../../static/staimg/right.png')"
                width="9"
                style="object-fit: contain"
                alt=""
              ></b-img>
            </div>
          </div>
        </div>
      </b-row>
    </div>
    <!-- 手机端的详情 图片 -->
    <div v-if="selType == '11'">
      <b-row class="mt-4" v-if="windowWidth < 750">
        <b-col cols="" style="">
          <div class="d-flex justify-content-between align-items-center">
            <div class="sameimg" style="width: 100%; height: 200px">
              <b-skeleton
                animation="wave"
                height="100%"
                width="100%"
              ></b-skeleton>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- 点击的图片 -->
    <b-row class="mt-3 mb-5" v-if="selType == '8'">
      <b-col class="">
        <div
          class=""
          style="
            width: 100%; /* 设置容器的高度，使其具有可滚动性 */
            overflow: hidden;
            overflow-x: auto; /* 允许在Y轴上滚动（垂直滚动） */
            border: 1px solid #ccc; /* 可选：添加边框以更好地可视化容器 */
            padding: 10px;
            height: 84px;
          "
        >
          <div
            class=""
            style="display: flex"
            :style="{ height: windowWidth < 800 ? '75px' : '80px' }"
          >
            <div
              class="d-flex justify-content-between align-items-center"
              :style="{ width: 106 * 5 + 'px' }"
              style="margin: 0 auto; height: 100%"
            >
              <div
                v-for="(item, index) in 5"
                :key="index"
                class="poinc isoneStylesw"
              >
                <b-skeleton
                  animation="wave"
                  height="57px"
                  width="106px"
                ></b-skeleton>
              </div>
            </div>
          </div>
        </div>
        <!-- <scroll-view
          scroll-x="true"
          :show-scrollbar="false"
          style="height: 60px"
        >
          <div
            class="d-flex justify-content-between align-items-center"
            :style="{ width: 106 * 5 + 'px' }"
            style="margin: 0 auto; height: 100%"
          >
            <div
              v-for="(item, index) in 5"
              :key="index"
              class="poinc isoneStylesw"
            >
              <b-skeleton
                animation="wave"
                height="57px"
                width="106px"
              ></b-skeleton>
            </div>
          </div>
        </scroll-view> -->
      </b-col>
    </b-row>
    <!-- 详情  内容-->
    <b-row class="mb-5 mt-2" v-if="selType == '7'">
      <b-col>
        <b-skeleton animation="wave" height="30px" width="60%"></b-skeleton>
        <b-skeleton animation="wave" height="30px" width="80%"></b-skeleton>
        <b-skeleton animation="wave" height="30px" width="80%"></b-skeleton>
      </b-col>
    </b-row>
    <!-- 小卡片 一行5个 -->

    <b-row
      v-if="selType == '17'"
      class="pb-4 d-flex mt-2"
      cols="2"
      cols-sm="3"
      cols-md="4"
      cols-lg="5"
      style="margin-right: 2px; cursor: pointer"
    >
      <b-col
        class="mb-2 mt-2"
        v-for="(item, index) in 12"
        :key="index"
        style=""
      >
        <div
          class="class-kuai"
          style="box-sizing: border-box; padding: 15px; border-radius: 18px"
        >
          <div
            class=""
            style="
              background-color: transparent;
              height: 10%;
              box-sizing: border-box;
              border-radius: 8px;
              overflow: hidden;
            "
          >
            <b-skeleton
              animation="wave"
              :height="windowWidth < 420 ? '100px' : '160px'"
              width="100%"
            ></b-skeleton>
          </div>
          <div
            class="item-title fontstylewrap mt-1"
            style="
              font-size: 16px;
              text-align: left;
              width: 100%;
              font-weight: bold;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
          >
            <b-skeleton
              animation="wave"
              height="30px"
              width="80px"
            ></b-skeleton>
          </div>

          <div class="d-flex justify-content-start align-items-center">
            <div
              class=""
              style="
                border: none;
                font-size: 12px;
                background-color: #e1e3e7;
                border-radius: 8px;
                margin-top: 8px;
              "
            >
              <b-skeleton
                animation="wave"
                height="20px"
                width="40px"
              ></b-skeleton>
            </div>
          </div>
          <div
            class=""
            style="font-size: 14px; text-align: left; margin-top: 8px"
          >
            <b-skeleton animation="wave" height="30px" width="50%"></b-skeleton>
            <b-skeleton
              animation="wave"
              height="30px"
              width="100%"
            ></b-skeleton>
          </div>

          <div style="margin-top: 12px">
            <b-skeleton
              animation="wave"
              height="30px"
              width="100%"
            ></b-skeleton>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- 帮助 -->
    <b-row
      v-if="selType == '18'"
      class="pb-4 d-flex mt-2"
      style="margin-right: 2px; cursor: pointer"
    >
      <b-col class="mb-2 mt-2" style="">
        <b-skeleton
          style="margin-bottom: 15px"
          animation="wave"
          height="30px"
          width="80px"
        ></b-skeleton>
        <b-skeleton
          animation="wave"
          :height="windowWidth < 420 ? '150px' : '300px'"
          width="100%"
        ></b-skeleton>

        <b-skeleton
          animation="wave"
          style="margin-top: 20px"
          :height="windowWidth < 420 ? '50px' : '100px'"
          width="100%"
        ></b-skeleton>

        <b-skeleton
          style="margin-bottom: 15px"
          animation="wave"
          height="30px"
          width="80px"
        ></b-skeleton>
      </b-col>
    </b-row>
    <!-- 标题 -->
    <b-row v-if="selType == '19'">
      <b-col class="m-1" style="">
        <b-skeleton
          style="margin-bottom: 15px"
          animation="wave"
          height="30px"
          width="80px"
        ></b-skeleton>
      </b-col>
    </b-row>
    <b-row v-if="selType == '20'" align-h="between" class="mt-4 mb-5">
      <b-card
        class="tw-w-full tw-mb-4"
        v-for="item in 8"
        :key="item"
        style="border: none"
      >
        <b-skeleton animation="wave" height="12px" width="30%"></b-skeleton>
        <b-skeleton
          class="tw-mt-1"
          animation="wave"
          height="12px"
          width="100%"
        ></b-skeleton>
        <b-skeleton
          class="tw-mt-1"
          animation="wave"
          height="12px"
          width="100%"
        ></b-skeleton>
        <b-skeleton
          class="tw-mt-1"
          animation="wave"
          height="12px"
          width="100%"
        ></b-skeleton>
        <div class="tw-flex tw-justify-end tw-mt-1">
          <b-skeleton animation="wave" height="12px" width="40%"></b-skeleton>
        </div>
      </b-card>
      <!-- <b-col lg="6" md="8" v-for="item in 4" :key="item" class="mb-2">
        <b-skeleton animation="wave" height="56px" width="100%"></b-skeleton>
      </b-col> -->
    </b-row>

    <b-row v-if="selType == '21'" class="tw-pt-16 tw-pb-10">
      <div
        class="tw-w-full tw-flex tw-justify-center tw-items-center tw-flex-col"
      >
        <b-skeleton animation="wave" height="140px" width="140px"></b-skeleton>
        <b-skeleton
          class="tw-mt-6"
          animation="wave"
          height="34px"
          width="20%"
        ></b-skeleton>
        <b-skeleton
          class="tw-mt-2"
          animation="wave"
          height="24px"
          width="50%"
        ></b-skeleton>
        <b-skeleton
          class="tw-mt-1"
          animation="wave"
          height="24px"
          width="50%"
        ></b-skeleton>
        <b-skeleton
          class="tw-mt-1"
          animation="wave"
          height="24px"
          width="50%"
        ></b-skeleton>
        <b-skeleton
          class="tw-mt-6"
          animation="wave"
          height="24px"
          width="10%"
        ></b-skeleton>
        <div
          class="tw-mt-5 tw-flex tw-w-full tw-justify-center tw-items-center"
        >
          <b-skeleton animation="wave" height="24px" width="10%"></b-skeleton>
          <b-skeleton
            class="tw-ml-2"
            animation="wave"
            height="24px"
            width="10%"
          ></b-skeleton>
        </div>
      </div>
    </b-row>
    <!-- 大卡片 文档列表 一行3个-->
    <b-row
      v-if="selType == '22'"
      class="pb-4 d-flex"
      cols="1"
      cols-sm="1"
      cols-md="2"
      cols-lg="4"
    >
      <b-col class="mb-3" v-for="(ite, ind) in 10" :key="ind">
        <div
          class="d-flex flex-column justify-content-between pushpub align-items-start"
          style="padding: 10px"
        >
          <div
            style="
              width: 100%;
              border-radius: 8px;
              text-align: center;

              color: #014099;
              font-weight: 600;
              font-size: 18px;
              word-wrap: break-word;
            "
            class="mt-3 p-1"
          >
            <b-skeleton animation="wave" width="50%"></b-skeleton>
          </div>
          <div
            class="mt-2"
            style="
              border-radius: 8px;
              overflow: hidden;
              height: 150px;
              width: 100%;
            "
            :style="{ height: windowWidth < 751 ? '250px' : '200px' }"
          >
            <b-skeleton
              animation="wave"
              width="100%"
              height="200px"
            ></b-skeleton>
          </div>

          <div
            style="
              width: 100%;
              border-radius: 8px;
              text-align: center;

              color: #014099;
              font-weight: 600;
              font-size: 18px;
              word-wrap: break-word;
            "
            class="mt-3 p-1"
          >
            <b-skeleton animation="wave" width="100%"></b-skeleton>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- 导航产品 文档列表 一行4个-->
    <b-row
      v-if="selType == '23'"
      class="pb-4 d-flex"
      cols="1"
      cols-sm="1"
      cols-md="2"
      cols-lg="4"
    >
      <b-col class="mb-3" v-for="(ite, ind) in 8" :key="ind">
        <div
          style="
            width: 100%;
            border-radius: 8px;
            text-align: center;

            color: #014099;
            font-weight: 600;
            font-size: 18px;
            word-wrap: break-word;
          "
          class="mt-3 p-1"
        >
          <b-skeleton animation="wave" width="50%"></b-skeleton>
        </div>
        <div
          class="d-flex flex-column justify-content-between pushpub align-items-start"
          style="padding: 10px"
        >
          <div
            class="mt-2"
            style="
              border-radius: 8px;
              overflow: hidden;
              height: 100px;
              width: 100%;
            "
            :style="{ height: windowWidth < 751 ? '250px' : '100px' }"
          >
            <b-skeleton
              animation="wave"
              width="100%"
              height="100px"
            ></b-skeleton>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowWidth: 0, // 存储当前窗口宽度的变量
    };
  },
  props: {
    selType: {
      type: String,
      default: "0",
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getScreenWidth);
  },
  mounted() {
    this.getScreenWidth();
    window.addEventListener("resize", this.getScreenWidth);
  },
  methods: {
    // 获取屏幕宽度
    getScreenWidth() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped lang="scss">
.swbaner {
  height: 300px;
}

.swbaner2 {
  height: 140px;
  border-radius: 15px;
  overflow: hidden;
}

.pushpub {
  border-radius: 8px;
  color: #1a1a1a;
  background: #f7f8fa;

  .pushimg {
    vertical-align: middle;
  }

  .pushtil {
    font-size: 16px;
    width: 100%;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pushtyp {
    font-size: 12px;
    background-color: #e1e3e7;
    border-radius: 8px;
    padding: 3px 5px;
  }

  .pushtyps {
    font-size: 12px;
    background-color: #e1e3e7;
    border-radius: 8px;

    display: inline-block;
  }

  .pushcont {
    height: 40px;
    font-size: 14px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .pushcontprice {
    width: 100%;
    border-radius: 8px;
    text-align: center;
    background-color: #dee7f3;
    color: #014099;
    font-weight: 600;
    font-size: 18px;
    overflow: hidden;
    word-wrap: break-word;

    span {
      font-weight: 500;
      color: rgba(1, 64, 153, 0.6);
      font-size: 14px;
      margin-left: 5px;
    }
  }
}

.bgimg {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;

  height: 280px;

  .bgtop {
    color: #4e6276;
    position: absolute;
    left: 5%;
    bottom: 65%;
    font-size: 24px;
    font-weight: bold;
    width: 80%;
  }

  .bgcen {
    color: #1a1a1a;
    position: absolute;
    left: 5%;
    bottom: 50%;
    font-size: 14px;
    width: 80%;
  }

  .bgbtn {
    border: 1px solid #4e6276;
    color: #4e6276;
    position: absolute;
    left: 5%;
    bottom: 25%;
  }
}

.isoneStylesw {
  margin-right: 5px;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid transparent;
}
</style>
